import type { PropsWithChildren } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { IconButton, Modal, WebsiteChipItem } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

interface IHeaderGroupProps extends PropsWithChildren {
    title: string;
}

const HeaderGroup = ({ children, title }: IHeaderGroupProps) => (
    <Flex
        gap="8px"
        alignItems="center"
    >
        <Text
            fontVariant="input2"
            color={colorsPalettes.carbon[250]}
        >
            {title}
        </Text>
        {children}
    </Flex>
);

interface IModalHeaderProps {
    domain: string;
    favicon: string;
    onClose: () => void;
    children: React.ReactNode;
}

const ModalHeaderRoot = ({ domain, favicon, onClose, children }: IModalHeaderProps) => {
    const { translate } = useTranslate();
    return (
        <Modal.Header withBorder>
            <Flex
                justifyContent="space-between"
                alignItems="center"
                width="100%"
            >
                <Flex
                    gap="16px"
                    alignItems="center"
                >
                    <HeaderGroup title={translate("activation.alerts.cards.display-ads.modal.header.competitor")}>
                        <WebsiteChipItem
                            text={domain}
                            image={favicon}
                            hideActionButton
                        />
                    </HeaderGroup>
                    {children}
                </Flex>
                <IconButton
                    iconSize="sm"
                    iconName="clear"
                    type="flat"
                    onClick={onClose}
                />
            </Flex>
        </Modal.Header>
    );
};

const InfoGroup = ({ title, children }: IHeaderGroupProps) => (
    <HeaderGroup title={title}>
        <Text
            fontVariant="subtitle1"
            color={colorsPalettes.carbon[500]}
            data-automation="modal-header-info-group-text"
        >
            {children}
        </Text>
    </HeaderGroup>
);

export const ModalHeader = Object.assign(ModalHeaderRoot, {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- compound component pattern
    InfoGroup,
});
